export default [
  {
    path: '/activity-20251218-main',
    component: () => import('./Page.vue'),
    meta: { title: '幻神震撼上线', id: 14 },
  },
]
